export default __webpack_public_path__ + "static/media/msf_s1.a4c7606d.png";